/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import sbp from '@sbp/sbp'
import Badge from '../../../../frontend/views/components/Badge.vue'
import NotificationBell from '../../../../frontend/views/containers/notifications/NotificationBell.vue'
import GroupsList from './GroupsList.vue'
import Profile from './Profile.vue'
import Toggle from '../../../../frontend/views/components/Toggle.vue'
import ListItem from '../../../../frontend/views/components/ListItem.vue'
import { mapState, mapGetters } from 'vuex'
import { OPEN_MODAL } from '../../../../frontend/utils/events.js'
import { DESKTOP } from '../../../../frontend/views/utils/breakpoints.js'
import { showNavMixin, fetchNews } from '../../../../frontend/views/utils/misc.js'
import { GLOBAL_DASHBOARD_SETTINGS } from '../../../../frontend/views/pages/GlobalDashboard.vue'
import { debounce } from 'turtledash'

const __vue_script__ = ({
  name: 'Navigation',
  mixins: [showNavMixin],
  components: {
    Badge,
    Toggle,
    NotificationBell,
    GroupsList,
    Profile,
    ListItem
  },
  data () {
    return {
      config: {
        debounceResize: debounce(this.checkIsTouch, 250),
        globalDashboard: Object.entries(GLOBAL_DASHBOARD_SETTINGS)
          .map(([key, entry]) => ({ ...entry, id: key }))
      },
      ephemeral: {
        isActive: false,
        isTouch: null,
        latestNewsDate: null
      }
    }
  },
  created () {
    this.checkIsTouch()
    this.checkForNewNews()
  },
  mounted () {
    // TODO - Create a single resize listener to be reused on components
    window.addEventListener('resize', this.config.debounceResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.config.debounceResize)
  },
  watch: {
    $route (to, from) {
      const isDifferentPage = from.path !== to.path
      if (this.ephemeral.isActive && isDifferentPage) {
        this.ephemeral.isActive = false
      }
    }
  },
  computed: {
    ...mapState(['currentGroupId', 'loggedIn']),
    ...mapGetters([
      'groupsByName',
      'colors',
      'totalUnreadNotificationCount',
      'groupUnreadMessages',
      'ourPreferences'
    ]),
    currentGroupUnreadMessagesCount () {
      return !this.currentGroupId ? 0 : this.groupUnreadMessages(this.currentGroupId)
    },
    logo () {
      const name = this.colors.theme === 'dark' ? '-white' : ''
      return `/assets/images/logo-transparent${name}.png`
    },
    isInert () {
      return !this.ephemeral.isActive && this.ephemeral.isTouch
    },
    notApprovedToGroupYet () {
      // TODO: once the relevant work is implemented on back-end, this check logic needs to be updated accordingly
      return this.$route.path === '/pending-approval'
    },
    isInGlobalDashboard () {
      return this.$route.path.startsWith('/global-dashboard')
    },
    hasNewNews () {
      // Don't show badge if we're currently on the news page
      if (this.$route.path === '/global-dashboard/news-and-updates') {
        return false
      }

      // Check if there's a stored last seen date
      const lastSeenNewsDate = this.ourPreferences?.lastSeenNewsDate

      // If no last seen date is stored, don't show badge
      if (!lastSeenNewsDate || !this.ephemeral.latestNewsDate) {
        return false
      }

      // Compare the latest news date with the last seen date
      const lastSeen = new Date(lastSeenNewsDate)
      const latest = new Date(this.ephemeral.latestNewsDate)

      return latest > lastSeen
    }
  },
  methods: {
    toggleMenu () {
      this.ephemeral.isActive = !this.ephemeral.isActive
    },
    openModal (mode) {
      sbp('okTurtles.events/emit', OPEN_MODAL, mode)
    },
    checkIsTouch () {
      this.ephemeral.isTouch = window.innerWidth < DESKTOP
    },
    onMenuItemsClick () {
      // Close the menu when a menu item is clicked.
      this.ephemeral.isActive = false
    },
    async checkForNewNews () {
      try {
        const data = await fetchNews()
        if (data.length > 0) {
          this.ephemeral.latestNewsDate = data[0].createdAt
        }
      } catch (error) {
        console.error('Failed to check for new news:', error)
      }
    }
  }
}        )

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"c-navigation",class:{ "is-active": _vm.ephemeral.isActive },attrs:{"aria-label":_vm.L("Main"),"data-test":"navMenu"}},[_c('toggle',{attrs:{"element":"navigation","aria-expanded":_vm.ephemeral.isActive,"data-test":"NavigationToggleBtn"},on:{"toggle":_vm.toggleMenu}},[(_vm.totalUnreadNotificationCount)?_c('badge',{staticClass:"c-toggle-badge",attrs:{"data-test":"dashboardBadge"}},[_vm._v(_vm._s(_vm.totalUnreadNotificationCount))]):(_vm.currentGroupUnreadMessagesCount)?_c('badge',{staticClass:"c-toggle-badge",attrs:{"data-test":"dashboardBadge"}},[_vm._v(_vm._s(_vm.currentGroupUnreadMessagesCount))]):_vm._e()],1),(_vm.groupsByName.length >= 1)?_c('groups-list',{attrs:{"inert":_vm.isInert}}):_vm._e(),_c('div',{staticClass:"c-navigation-wrapper",attrs:{"inert":_vm.isInert}},[(_vm.isInGlobalDashboard)?[_c('div',{staticClass:"c-navigation-header"},[_c('i18n',{staticClass:"sr-only",attrs:{"tag":"h1"}},[_vm._v("Global Dashboard Menu")]),_c('img',{staticClass:"c-logo",attrs:{"src":_vm.logo,"alt":"GroupIncome's logo"}})],1),_c('div',{staticClass:"c-navigation-body"},[_c('div',{staticClass:"c-navigation-body-top"},[_c('ul',{staticClass:"c-menu-list"},_vm._l((_vm.config.globalDashboard),function(entry){return _c('list-item',{key:entry.id,attrs:{"tag":"router-link","icon":entry.icon,"to":entry.routeTo,"badgeCount":entry.id === "news-and-updates" && _vm.hasNewNews ? 1 : 0,"data-test":"global-dashboard_" + entry.id}},[_vm._v(_vm._s(entry.title))])}),1)])])]:[_c('div',{staticClass:"c-navigation-header"},[_c('i18n',{staticClass:"sr-only",attrs:{"tag":"h1"}},[_vm._v("Main Menu")]),_c('router-link',{attrs:{"to":"/home"}},[_c('img',{staticClass:"c-logo",attrs:{"src":_vm.logo,"alt":"GroupIncome's logo"}})]),(!_vm.notApprovedToGroupYet)?_c('notification-bell',{attrs:{"data-test":"notificationBell"}}):_vm._e()],1),(!_vm.notApprovedToGroupYet && _vm.groupsByName.length)?_c('div',{staticClass:"c-navigation-body",on:{"click":function($event){$event.stopPropagation();return _vm.onMenuItemsClick($event)}}},[_c('div',{staticClass:"c-navigation-body-top"},[_c('ul',{staticClass:"c-menu-list"},[_c('list-item',{attrs:{"tag":"router-link","icon":"columns","to":"/dashboard","data-test":"dashboard"}},[_c('i18n',[_vm._v("Dashboard")])],1),_c('list-item',{attrs:{"tag":"router-link","icon":"chart-pie","to":"/contributions","data-test":"contributionsLink"}},[_c('i18n',[_vm._v("Contributions")])],1),_c('list-item',{attrs:{"tag":"router-link","icon":"tag","to":"/payments","data-test":"paymentsLink"}},[_c('i18n',[_vm._v("Payments")])],1),_c('list-item',{attrs:{"tag":"router-link","icon":"comments","to":"/group-chat","badgeCount":_vm.currentGroupUnreadMessagesCount,"data-test":"groupChatLink"}},[_c('i18n',[_vm._v("Chat")])],1),_c('list-item',{attrs:{"tag":"router-link","icon":"cog","to":"/group-settings","data-test":"groupSettingsLink"}},[_c('i18n',[_vm._v("Group Settings")])],1)],1),(_vm.groupsByName.length < 2)?_c('div',{staticClass:"c-navigation-separator"},[_c('button',{staticClass:"is-small is-outlined",attrs:{"data-test":"createGroup","aria-label":_vm.L("Add a group")},on:{"click":function($event){return _vm.openModal("GroupCreationModal")}}},[_c('i',{staticClass:"icon-plus is-prefix"}),_c('i18n',[_vm._v("Add a group")])],1)]):_vm._e()]),_c('div',{staticClass:"c-navigation-bottom"},[_c('ul',{staticClass:"c-menu-list-bottom"},[_c('i18n',{attrs:{"tag":"a","href":_vm.ALLOWED_URLS.BLOG_PAGE,"target":"_blank","rel":"noopener noreferrer"}},[_vm._v("Blog")]),_c('i18n',{attrs:{"tag":"a","href":_vm.ALLOWED_URLS.COMMUNITY_PAGE,"target":"_blank","rel":"noopener noreferrer"}},[_vm._v("Help & Feedback")]),_c('i18n',{attrs:{"tag":"a","href":_vm.ALLOWED_URLS.DONATE_PAGE,"target":"_blank","rel":"noopener noreferrer"}},[_vm._v("Donate")])],1)])]):_vm._e()],(_vm.showNav)?_c('div',{staticClass:"c-navigation-footer"},[_c('profile')],1):_vm._e()],2)],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-c8a4e864_0", { source: ".c-navigation[data-v-c8a4e864]{display:flex;flex-direction:row;font-weight:400;background:var(--general_2)}.c-navigation-wrapper[data-v-c8a4e864]{display:flex;flex-direction:column;min-width:14.375rem;justify-content:space-between;height:100%}.c-navigation-header[data-v-c8a4e864]{display:flex;justify-content:space-between;align-items:center;flex-shrink:0;padding:0 1rem;height:4.6rem;margin-bottom:-.1rem}.c-navigation-body[data-v-c8a4e864]{display:flex;overflow:auto;-webkit-overflow-scrolling:touch;flex-direction:column;justify-content:space-between;flex-grow:1}.c-navigation-separator[data-v-c8a4e864]{text-align:center;margin:1.5rem 1.5rem 0 1.5rem;border-top:1px solid var(--general_0);padding-top:1.5rem}.c-navigation-bottom[data-v-c8a4e864]{padding-top:2rem;padding-bottom:.5rem}.c-navigation-footer[data-v-c8a4e864]{flex-shrink:0}.c-menu-list-bottom[data-v-c8a4e864]{display:flex;flex-direction:column;margin-left:1rem;font-size:.75rem}.c-menu-list-bottom a[data-v-c8a4e864]{line-height:1.65rem;color:var(--text_1)}.c-menu-list-bottom a[data-v-c8a4e864]:focus,.c-menu-list-bottom a[data-v-c8a4e864]:hover{color:var(--text_0);outline:0}.c-logo[data-v-c8a4e864]{min-width:8rem;width:8rem}.c-toggle[data-v-c8a4e864]{left:100%}", map: undefined, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-c8a4e864"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "style>\n"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (true && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__